import users from './common/users'

export default {
    data: {
        getProject: {
            id: 1137,
            groups: [
                {
                    id: 2069,
                    name: null,
                    default: true,
                    members: [
                        {
                            id: 9625,
                            user: users['2'],
                            email: users['2'].email,
                            permission: 'owner',
                        },
                        {
                            id: 9626,
                            user: users['719'],
                            email: users['719'].email,
                            permission: 'admin',
                        },
                        {
                            id: 9632,
                            user: users['1'],
                            email: users['1'].email,
                            permission: 'admin',
                        },
                    ],
                },
                {
                    id: 2070,
                    name: 'Elétrica',
                    default: false,
                    members: [
                        {
                            id: 9627,
                            user: users['155'],
                            email: users['155'].email,
                            permission: 'admin',
                        },
                        {
                            id: 9628,
                            user: users['58'],
                            email: users['58'].email,
                            permission: 'employee',
                        },
                    ],
                },
                {
                    id: 2071,
                    name: 'Hidráulica',
                    default: false,
                    members: [
                        {
                            id: 9629,
                            user: users['131'],
                            email: users['131'].email,
                            permission: 'employee',
                        },
                    ],
                },
            ],
        },
    },
}
